export default __webpack_public_path__ + "static/media/TT Norms Pro Black.aea678c3.otf";